"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { SvgIconType } from '../SvgIcon/svg-icon-type.mjs';
import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { forwardRef } from 'react';
import { tv } from 'tailwind-variants';
import { IconButton } from '../../ui-kit/icon-button.mjs';
import { SvgIcon } from '../SvgIcon/index.mjs';

const dropdownClearSearchButtonRecipe = tv({
  slots: withSlotScopeClasses("dropdown-clear-search-button", {
    button: "h-6 w-6 min-w-[unset] rounded-md text-fg-muted data-[current]:bg-bg-muted",
    icon: "w-4 h-4"
  })
});
const ClearSearchButton = forwardRef(
  ({ className, ...props }, ref) => {
    const { button, icon } = dropdownClearSearchButtonRecipe();
    return /* @__PURE__ */ jsx(
      IconButton,
      {
        ref,
        variant: "ghost",
        colorPalette: "gray",
        className: button({ className }),
        "aria-label": "Clear search",
        ...props,
        children: /* @__PURE__ */ jsx(SvgIcon, { type: SvgIconType.Close, className: icon() })
      }
    );
  }
);

export { ClearSearchButton };
